<template>
  <div>
    <div class="detail">
      <div class="banner"></div>
      <div class="home-btn" @click="toHome()"></div>
      <div class="main-content">
        <span class="pc-back" @click="back"></span>
        <span class="divider"></span>
        <h1 class="title">{{ title }}</h1>
        <div class="news-info-content">
          <span class="time">{{ time }}</span>
        </div>
        <div class="p-content">
          <p class="p-detail">
            {{ first_paragraph }}
          </p>
        </div>
        <div v-for="content in contents" :key="content.id" class="p-content">
          <img v-if="content.img" :src="content.img" alt="" />
          <h1 v-if="content.subTitle" class="p-title">
            {{ content.subTitle }}
          </h1>
          <p class="p-detail" v-html="content.paragraph"></p>
        </div>
      </div>
    </div>
    <!-- 浮窗 -->
    <SiderBar />
  </div>
</template>

<script>
import SiderBar from "../components/SiderBar";
import jsonData from "../assets/data.js";
export default {
  data() {
    const currentData = jsonData[this.$route.query.type].find(
      (el) => el.id === this.$route.query.id
    );
    return currentData;
  },
  created() {},
  methods: {
    back() {
      this.$router.go(-1);
    },
    toHome() {
      this.$router.push("/");
    },
  },
  components: {
    SiderBar,
  },
};
</script>

<style lang="scss">
// app
@media screen and (max-width: 768px) {
  .detail {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(../assets/images/m_details.png) 0 0 no-repeat;
    background-size: cover;

    .banner {
      width: 100%;
      height: 310px;
      background: url(../assets/images/m_detial_banner.jpg) no-repeat 0 0;
      background-size: cover;
            margin-top: 100px;

    }

    .home-btn {
      display: none;
    }

    .main-content {
      position: relative;
      padding: 0px 30px 93px 30px;
      .pc-back {
        top: 15px;
        left: 20px;
        width: 42px;
        height: 42px;
        position: absolute;
        cursor: pointer;
        background: url(../assets/images/back_btn.png) no-repeat 0 0;
        background-size: contain;
      }

      .divider {
        position: absolute;
        top: 73px;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: #dfbd99;
      }

      .title {
        margin: 134px 0 0 0;
        color: #404040;
        text-align: center;
        font-size: 34px;
        line-height: 36px;
        font-family: "GenJyuuGothic-P-Regular";
      }
      .news-info-content {
        margin: 30px 0px 43px 0px;
        font-family: "GenJyuuGothic-P-Regular";
        font-size: 24px;
        line-height: 29px;
        text-align: center;
        color: #404040;
        .time {
          margin: 0 0 0 22px;
        }
        span {
          text-align: center;
        }
      }

      .p-content {
        .p-title {
          font-size: 22px;
          color: #bf703c;
          margin: 35px 0px;
          line-height: 29px;
          text-align: left;
          font-family: "GenJyuuGothic-P-Regular";
        }
        img {
          margin: 30px auto 30px auto;
          width: 100%;
          display: block;
          object-fit: contain;
        }
        .p-detail {
          font-size: 19px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #404040;
          line-height: 45px;
          font-family: "GenJyuuGothic-P-Regular";
          white-space: pre-wrap;
        }
      }
    }
  }
}
// pc
@media screen and (min-width: 769px) {
  .detail {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    background: url(../assets/images/pc_details.png) 0 0 no-repeat;
    background-size: cover;

    .banner {
      width: 100%;
      height: 724px;
      background: url(../assets/images/detail_banner.jpg) no-repeat 0 0;
      background-size: cover;
    }

    .home-btn {
      position: absolute;
      width: 190px;
      height: 70px;
      right: 443px;
      top: 380px;
      background: url(../assets/images/list_back.png) no-repeat 0 0;
      background-size: cover;
    }

    .main-content {
      width: 924px;
      position: relative;
      padding: 80px 0px 127px 0px;
      .pc-back {
        width: 42px;
        height: 42px;
        top: 76px;
        position: absolute;
        cursor: pointer;
        background: url(../assets/images/back_btn.png) no-repeat 0 0;
        background-size: contain;
      }

      .title {
        color: #404040;
        text-align: center;
        font-size: 34px;
        line-height: 40px;
        width: 800px;
        position: relative;
        left: 50%;
        margin-left: -400px;
        font-family: "GenJyuuGothic-P-Medium";
      }
      .news-info-content {
        margin: 30px 0px 36px 0px;
        font-family: "GenJyuuGothic-P-Regular";
        font-size: 24px;
        line-height: 29px;
        color: #404040;
        .time {
          margin: 19px 0 0 0;
          font-family: "NotoSansCJKsc-Regular";
        }
        span {
          display: block;
          text-align: center;
        }
      }

      .p-content {
        .p-title {
          font-size: 22px;
          color: #bf703c;
          margin: 35px 0px;
          line-height: 29px;
          text-align: left;
          font-family: "NotoSansCJKsc-DemiLight";
        }
        img {
          margin: 40px auto 40px auto;
          max-width: 924px;
          display: block;
          object-fit: contain;
        }
        .p-detail {
          font-size: 19px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 1px;
          color: #404040;
          line-height: 45px;
          font-family: "GenJyuuGothic-P-Regular";
          white-space: pre-wrap;
        }
      }
    }
  }
}
</style>
